import { useIntl } from "react-intl";

import { RoadmapSubscriptionForm } from "./roadmap-subscription-form.tsx";

export interface CloudRoadmapSubscriptionFormProps {
    lastUpdated: string;
}

export const CloudRoadmapSubscriptionForm = (
    props: CloudRoadmapSubscriptionFormProps
) => {
    const { lastUpdated } = props;

    const intl = useIntl();

    return (
        <RoadmapSubscriptionForm
            lastUpdated={lastUpdated}
            formId="a9ce9de2-9120-4fa9-a982-12a369254cad"
            formImage={{
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5i7x2g3g1ap10qp6r31tyi2tw4ho75dq.png",
                alt: intl.formatMessage({
                    id: "roadmapSubscription.image.alt",
                    defaultMessage: "Cloud Roadmap"
                })
            }}
            heading={intl.formatMessage({
                id: "roadmapSubscription.heading",
                defaultMessage: "Cloud Roadmap"
            })}
            description={intl.formatMessage({
                id: "roadmapSubscription.description",
                defaultMessage:
                    "Check out the latest features in Cloud and learn about what we're working on. Subscribe to receive an email each quarter highlighting our newly released features, updated time frames, and more."
            })}
        />
    );
};
